var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "pending-order-dialog",
      attrs: {
        visible: _vm.visible,
        width: "820px",
        center: "",
        "append-to-body": true,
        "before-close": _vm.setOrderFlag,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "pending-order-content" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("i", {
              staticClass: "el-icon-close",
              staticStyle: { "font-size": "20px", cursor: "pointer" },
              on: { click: _vm.setOrderFlag }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "flex-row-start-center title" }, [
              _c("i", { staticClass: "el-icon-warning" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n            以下售后单即将超过处理时效，请尽快处理\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("asOrder", {
              ref: "asRef",
              on: { setOrderFlag: _vm.setOrderFlag }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-476982f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476982f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pendingAsOrder/index.vue
// module id = null
// module chunks = 